import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { SxProps } from '@cp/ds';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { styled } from '@youhelp-ru/ui';
import CornerChatBubblesSvg from 'src/assets/shapes/cornerChatBubbles.svg';

interface CatalogBannerFreeSearchProps {
  onClick?: () => void;
  sx?: SxProps;
}

const Root = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  height: '100%',
});

export const CatalogBannerFreeSearch: React.FC<CatalogBannerFreeSearchProps> = ({ onClick, sx }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  const handleClick = () => {
    onClick?.();
  };

  const paymentsCaption = (
    <Typography component="div" sx={isMobile ? { flex: 1 } : undefined} variant="caption bold">
      Оплата только при успешном заказе
    </Typography>
  );

  return (
    <Root sx={mergeSx(undefined, sx)}>
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          pointerEvents: 'none',
          lineHeight: 0,
          zIndex: 0,
          ...(isMobile
            ? { right: -6, top: -5, width: 136, height: 136 }
            : { right: 14, top: 16, width: 106, height: 106 }),
          '& svg': { display: 'block', width: '100%', height: '100%' },
          '& svg g': { opacity: 1 },
        }}
      >
        <CornerChatBubblesSvg />
      </Box>

      <Stack
        direction="column"
        sx={{
          zIndex: 1,
          alignItems: isMobile ? 'flex-start' : 'stretch',
          gap: isMobile ? 1 : 2,
          p: isMobile ? 1.5 : 2.5,
          textAlign: 'left',
        }}
      >
        <Typography component="div" variant="h2">
          Бесплатный старт
        </Typography>

        <Typography component="div" sx={{ color: theme.palette.gray }} variant="caption">
          Объявления, приглашения и переписка — бесплатно.
        </Typography>

        {isMobile ? (
          <Stack alignItems="center" direction="row" gap={1} justifyContent="space-between" sx={{ width: 1 }}>
            {paymentsCaption}
            <Button color="pink" onClick={handleClick} size="small" sx={{ flexShrink: 0 }} variant="primary">
              Хорошо
            </Button>
          </Stack>
        ) : (
          <>
            {paymentsCaption}
            <Button color="pink" onClick={handleClick} size="small" variant="primary">
              Хорошо
            </Button>
          </>
        )}
      </Stack>
    </Root>
  );
};
